module.exports = __webpack_public_path__ + "img/dispatch-icon-2.7bb75207.png";